import RadioGroupFilter, {
  createRadioFilterTemplate,
} from '@/filters/RadioGroup';

export const options = [
  {
    key: true,
    label: 'Отображаемые товары',
  },
  {
    key: false,
    label: 'Скрытые товары',
  },
];

export const createVisibilityFilter = createRadioFilterTemplate({
  initialValue: options[0].key,
  options,
});

export default RadioGroupFilter;
